import React from 'react';
import { getContext } from 'common';
import Styled from './styles';

export interface FloatingPanelButtonsProps extends React.ComponentPropsWithRef<'div'> {
  /** Content of FloatingPanelButtons. Place <IconButton /> and <Icon /> components here. */
  children?: React.ReactNode;
}

/** FloatingPanelButtons component, place minimize, maximize and close buttons here. */
const FloatingPanelButtons = React.forwardRef<HTMLElement, FloatingPanelButtonsProps>((props: FloatingPanelButtonsProps, ref) =>
  getContext(({ RTL }) => {
    const { children, ...otherProps } = props;
    return (
      <Styled.FloatingPanelButtons $rtl={RTL} ref={ref} {...otherProps}>
        {children}
      </Styled.FloatingPanelButtons>
    );
  }));

FloatingPanelButtons.displayName = 'FloatingPanelButtons';

FloatingPanelButtons.defaultProps = {
  children: undefined
};

export default FloatingPanelButtons;
